<template>
  <section class="catalog-range">
    <input
      v-model="minSave"
      :name="min.CONTROL_NAME"
      :placeholder="min.VALUE"
      type="text"
      class="catalog-range__input"
      @change="validateMinValue"
    />
    <svg
      class="catalog-range__minus"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.18762 9.21265H15.9128V10.8877H4.18762V9.21265Z" fill="#5F5F67" />
    </svg>

    <input
      v-model="maxSave"
      :name="max.CONTROL_NAME"
      :placeholder="max.VALUE"
      type="text"
      class="catalog-range__input"
      @change="validateMaxValue"
    />
    <button type="submit" class="catalog-range__button">ОК</button>
  </section>
</template>

<script>
export default {
  name: 'CatalogRange',
  props: ['result'],
  data() {
    return {
      minSave: this.result?.VALUES?.MIN?.HTML_VALUE,
      maxSave: this.result?.VALUES?.MAX?.HTML_VALUE,
    };
  },
  computed: {
    min() {
      return this.result.VALUES.MIN;
    },
    max() {
      return this.result.VALUES.MAX;
    },
  },
  watch: {
    result(newValue) {
      const { MIN, MAX } = newValue.VALUES;

      this.minSave = MIN.HTML_VALUE;
      this.maxSave = MAX.HTML_VALUE;
    },
  },
  methods: {
    validateMinValue({ target }) {
      const max = +this.max.VALUE;
      const min = +this.min.VALUE;
      const currentMax = this.maxSave;
      const value = +target.value;

      if (value < min || value >= max || (currentMax && value >= currentMax)) {
        this.minSave = min;
      }
    },
    validateMaxValue({ target }) {
      const max = +this.max.VALUE;
      const min = +this.min.VALUE;
      const currentMin = this.minSave;
      const value = +target.value;

      if (value > max || value <= min || value <= currentMin) {
        this.maxSave = max;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-range {
  display: flex;
  align-items: center;
  gap: 8px;
  &__input {
    border: 1px solid #c8c8c8;
    height: 44px;
    padding: 0 16px;
    font-size: rem(16);
    font-weight: 500;
    line-height: 125%;
    width: 100%;
  }
  &__minus {
    flex-shrink: 0;
  }
  &__button {
    height: 44px;
    padding: 0 18px;
    border: none;
    background-color: #f3f3f6;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
}
</style>
